import { Link, useLocation } from "react-router-dom";
import React, { useState, useRef, useEffect } from "react";

const Header = () => {
  const location = useLocation().pathname;
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  let fullName = localStorage.getItem("fullName");
  let email = localStorage.getItem("email");

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (event) => {
      if (!dropdownRef.current) return;
      // If click/tap is outside the dropdown container, close it.
      if (!dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <>
      <nav
        className={`navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row ${location.pathname === "/" || location.pathname === "/forgot-password"
          ? "d-none"
          : ""
          }`}
      >
        <div className="navbar-brand-wrapper d-flex align-items-center">
          <Link className="navbar-brand brand-logo" to="/dashboard">
            <img src="/images/sb-logo.png" alt="logo" className="logo-dark" style={{ width: "90%", height: "auto" }} />
          </Link>
        </div>
        <div className="navbar-menu-wrapper d-flex align-items-center flex-grow-1">
          <h5 className="mb-0 font-weight-medium d-none d-lg-flex">
            Welcome to Sarees Bazaar Panel!
          </h5>
          <ul className="navbar-nav navbar-nav-right ml-auto">
            <li
              className="nav-item dropdown d-none d-xl-inline-flex user-dropdown"
              ref={dropdownRef}
            >
              <div
                className="nav-link"
                onClick={toggleDropdown}
                style={{ cursor: "pointer" }}
              >
                <span className="font-weight-normal">{fullName}</span>

                {/* Arrow Icon */}
                <i
                  className={`ml-2 ${isOpen ? "icon-arrow-up" : "icon-arrow-down"
                    }`}
                />
              </div>

              {isOpen && (
                <div className="dropdown-menu dropdown-menu-right navbar-dropdown show">
                  <div className="dropdown-header text-center">
                    <p className="mb-1">Sarees Bazaar</p>
                    <p className="font-weight-light text-muted mb-0">
                      {email}
                    </p>
                  </div>

                  <Link className="dropdown-item" to="/my-profile">
                    <i className="dropdown-item-icon icon-user" style={{ color: "#0b73bc" }} />
                    <span>My Profile</span>
                  </Link>

                  <div className="dropdown-divider"></div>

                  <div className="dropdown-item" onClick={handleLogout}>
                    <i className="dropdown-item-icon icon-power text-danger" />
                    <span>Logout</span>
                  </div>
                </div>
              )}
            </li>
          </ul>
          <button
            className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
            type="button"
            data-toggle="offcanvas"
          >
            <span className="icon-menu" />
          </button>
        </div>
      </nav>
    </>
  );
};

export default Header;
